<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4" v-if="currentReserve">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0">Reserva</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'Reservas' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="card">
              <div class="card-body">
            <div class="row" v-if="currentReserve">
              <div class="col-md-6">
                <div>
                  <label class="form-control-label">
                    Usuario
                  </label>
                  <p>{{ currentReserve.user.firstname }} ({{ currentReserve.user.email }})</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Sendero
                  </label>
                  <p>{{ currentReserve.trail.name }}</p>
                </div>
              </div>
                <div>
                  <label class="form-control-label">
                    Participantes
                  </label>
                  <p> {{ currentReserve.places }}</p>
                </div>
                <div>
                  <label  class="form-control-label">
                    Dia
                  </label>
                  <p> {{ currentReserve.day }}</p>
              </div>
            </div>
          </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


     const route = useRoute();
     const store = useStore();

    const getCurrentReserve = async (id) => {
      return await store.dispatch("reserve/getReserveById", id);
    };

    const currentReserve = computed(() => store.state.reserve.currentReserve);

    onMounted(()=> {
      getCurrentReserve(route.params.id)
    });


</script>
